var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        stroke-miterlimit: 10;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m8.21,37.7c0-14.36,11.64-26,26-26,10.47,0,19.5,6.19,23.62,15.12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m55.62,52.46c-4.69,6.79-12.53,11.24-21.41,11.24-14.36,0-26-11.64-26-26"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 34.28,
    cy: 37.7,
    rx: 4.62,
    ry: 4.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.84,40.29h10.9v3.91h5.79l.04-3.91h5.23v-5.44h-22.02c-1.28-4.62-5.59-8.02-10.71-8.02-6.13,0-11.1,4.87-11.1,10.88s4.97,10.88,11.1,10.88c5.22,0,9.6-3.53,10.78-8.29h0s0,0,0,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/__Access.d242c3dd6cdd5b6a11c7f5d000e9298b.svg";
export { ForwardRef as ReactComponent };